// require('webpack-jquery-ui');
// require('webpack-jquery-ui/css'); 
// global.jQuery = require('jquery');

import  'jquery';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import "./Custom";